import axios from 'axios'
import { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router'
import urlSearchParams from '../../components/urlSearchParams'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { FeatureContext } from '../../context api/Features/FeatureContext'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { bulkUploadPopup, toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, ROUTES, success, getNewToken } from '../../shared/constants'
import moment from 'moment'

export const usePrimarySales = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const history = useHistory()
  const [primarySales, setPrimarySales] = useState(false)
  const { deleteNewPrimarySales, getNewPrimarySales, addNewPrimarySales } = useContext(FeatureContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState({})
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [pdfCsvData, setPdfCsvData] = useState({ headings: [], headingValues: [] })
  const [cancelToken, setCancelToken] = useState()

  useEffect(() => {
    if (cancelToken) {
      setLoading(true)
    }
  }, [cancelToken])

  const getAllPrimarySales = async (dto = {}) => {
    axios
      .get(API.GET_ALL_PRIMARY_SALES(urlSearchParams(dto)), {
        ...header,
        cancelToken: getNewToken(cancelToken, setCancelToken),
      })
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        getNewPrimarySales(data.data)
        setPaginate(data.paginate)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const addPrimarySales = (dto) => {
    setLoading(true)
    axios
      .post(API.ADD_PRIMARY_SALES, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('PrimarySales  Added Successfully', success)
        history.push(ROUTES.PRIMARY_SALES)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const updatePrimarySales = (dto) => {
    setLoading(true)
    axios
      .put(API.EDIT_PRIMARY_SALES, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('PrimarySales  Update Successfully', success)
        history.push(ROUTES.PRIMARY_SALES)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getPrimarySales = (dto) => {
    setLoading(true)
    axios
      .get(API.GET_PRIMARY_SALES(dto.primarySalesId), header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        setPrimarySales(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const deletePrimarySales = (dto, setSelected) => {
    setLoading(true)
    axios
      .delete(API.DELETE_PRIMARY_SALES(dto.primarySalesId), header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('PrimarySales Deleted Successfully', success)

        deleteNewPrimarySales(dto.primarySalesId)
        setSelected([])
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const deleteManyPrimarySales = (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_MANY_PRIMARY_SALES, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage(`${dto.primarySalesId.length} PrimarySales Deleted Successfully`, success)

        dto.primarySalesId.map((item) => deleteNewPrimarySales(item))
        setSelected([])
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const BulkUpload = async (dto) => {
    setLoading(true)
    axios
      .post(API.BULK_UPLOAD, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }

        {
          data.data.length || data.failedData.length ? bulkUploadPopup(data, addNewPrimarySales) : toastMessage('No Data Uploaded !', success)
        }

        const startDate = moment().startOf('month').toDate().toISOString()
        getAllPrimarySales()
        // bulkUploadPopup(data, addNewPrimarySales)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getPdfCsvData = async (dto = {}) => {
    setDownloadLoading(true)
    dto = { ...dto, download: 1 }
    axios
      .get(API.GET_ALL_PRIMARY_SALES(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setDownloadLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setPdfCsvData(data)
      })
      .catch((err) => {
        setDownloadLoading(false)
        if (err.response) {
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  return {
    addPrimarySales,
    getAllPrimarySales,
    deletePrimarySales,
    getPrimarySales,
    primarySales,
    updatePrimarySales,
    deleteManyPrimarySales,
    BulkUpload,
    getPdfCsvData,
    loading,
    paginate,
    downloadLoading,
    pdfCsvData,
  }
}
